export default "__VITE_ASSET__d5048a2f__$_?component__"